
import { youtube } from "../../portfolio";
import "./YouTube.css";

const YouTube = () => {
  if (!youtube.length) return null;

  return (
    <section className="section youtube" id="content">
      <h2 className="section__title">Content</h2>
      <div className="youtube__container">
        {youtube.map((vid, index) => (
          <div key={vid.title || index} className="youtube__item">
            <h3 className="youtube__title">{vid.title}</h3>
            <div className="youtube__video-wrapper">
              <iframe
                src={vid.embed_url}
                title={vid.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen={true}
                className="youtube__iframe"
              ></iframe>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default YouTube;
